import { NgModule } from '@angular/core';
import { ScheduleMeetingButtonComponent } from './schedule-meeting-button/schedule-meeting-button-component';
import { ScheduleMeetingDialogComponent } from './schedule-meeting-dialog/schedule-meeting-dialog-component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { MatChipGrid, MatChipInput, MatChipRemove, MatChipRow } from '@angular/material/chips';
import { DurationPipe } from '@galaxy/crm/integrations/meeting-event/src/pipes';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyTimezoneSelectorModule } from '@vendasta/galaxy/timezone-selector';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { MeetingSchedulerSharedModule } from '../../shared/meeting-scheduler-shared.module';

@NgModule({
  declarations: [ScheduleMeetingButtonComponent, ScheduleMeetingDialogComponent],
  exports: [ScheduleMeetingButtonComponent],
  imports: [
    MatButtonModule,
    MatIconModule,
    CommonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatDialogModule,
    TranslateModule,
    GalaxyFormFieldModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    GalaxyLoadingSpinnerModule,
    MatChipInput,
    MatChipRow,
    MatChipGrid,
    MatChipRemove,
    DurationPipe,
    GalaxyBadgeModule,
    MatSelectModule,
    GalaxyTimezoneSelectorModule,
    GalaxyButtonLoadingIndicatorModule,
    MeetingSchedulerSharedModule,
  ],
})
export class ScheduleMeetingButtonModule {}
